import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const incomingRfqsSlice = createSlice({
    name: 'ui/incoming-rfqs',
    initialState,
    reducers: listReducers
})

export const incomingRfqsActions = incomingRfqsSlice.actions
export default incomingRfqsSlice.reducer
